import Header from '../components/Header';
import Footer from '../components/Footer';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faArrowLeft, faStar } from "@fortawesome/free-solid-svg-icons";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { useEffect, useState } from 'react';
import BodyClassManager from '../components/BodyClassManager';
import { Link, useLocation, useNavigate } from "react-router-dom";
import myImage from '../assets/images/face-img1.png';

export default function Home() {
    var ideaSetting = {
        arrows: false,
        dots: true,
        infinite: true,
        adaptiveHeight:true,
        autoplay: true,
        autoplaySpeed: 5000,
        slidesToShow: 1,
        slidesToScroll: 1,
    };
    var awardSetting = {
        arrows: false,
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 5000,
        touchThreshold : 100,
        slidesToShow: 3,
        slidesToScroll: 3,
        centerMode: true,
        responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    var testimonialSetting = {
        arrows: false,
        dots: false,
        infinite: true,
        adaptiveHeight:true,
        autoplay: true,
        autoplaySpeed: 5000,
        touchThreshold : 100,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [{
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
  const [loading, setLoading] = useState(true);

   useEffect(() => {
        const timer = setTimeout(() => {
        setLoading(false);
        }, 200);
        return () => clearTimeout(timer);
    }, []);

    if (loading) {
    return (
        <div
        style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            background: "#fff", // optional background
        }}
        >
        <div
            style={{
            width: "50px",
            height: "50px",
            border: "5px solid #f3f3f3",
            borderTop: "5px solid #3498db",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
            }}
        />
        <style>
            {`
            @keyframes spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
            }
            `}
        </style>
        </div>
    );
    }

  return (
    <>
    
    <Header />

    <main className="m-0 home-pg">

        <div className="banner-wrapper">
            <div className="container">
                <div className="banner-top-cnt">
                    <div className="badge bg-light-grey rounded-pill">
                        Discover the future in every update.
                        <button type="button" className="icon-btn right-btn">
                            <FontAwesomeIcon icon={faArrowRight} />
                        </button>
                    </div>
                    <h2 className="title display-1">Burst Out of Your Bubble.<br/>Go For It.</h2>
                </div>
                <div className="banner-img-back-shape">
                    <img src={myImage} />
                </div>
                <div className="banner-bottom-cnt">
                    <h3 className="h2 subtitle">Bring Your Concept To Life.</h3>
                    <h5 className="h3 text-primary subtitleT">Researchers</h5>
                    <button type="button" className="btn btn-primary start-btn">Get Started</button>
                    <div className="button-list">
                        <span className="btn">Engineer</span>
                        <span className="btn">Design</span>
                        <span className="btn">Play</span>
                        <span className="btn">Launch</span>
                        <span className="btn">Relate</span>
                    </div>
                </div>
            </div>
        </div>

        <div className="trusted-logo-wrapper">
            <div className="container">
                <h2 className="title">Trusted by Professionals at</h2>
                <div className="logos-main">
                    <img src="https://upload.wikimedia.org/wikipedia/commons/a/a4/Abbott_Laboratories_logo.svg" alt="Abbott Laboratories"/>
                    <img src="https://upload.wikimedia.org/wikipedia/en/a/a6/GSK_logo_2014.svg" alt="gsk"/>
                    <img src="https://www.merck.com/wp-content/themes/cex-wpvip-mhh-merck-mco-theme/images/site-logo.svg" alt="merck"/>
                    <img src="https://upload.wikimedia.org/wikipedia/commons/b/be/JNJ_Logo_New.svg" alt="Johnson & Johnson"/>
                    <img src="https://upload.wikimedia.org/wikipedia/en/thumb/a/a4/Janssen_Pharmaceuticals_logo.svg/1024px-Janssen_Pharmaceuticals_logo.svg.png" alt="janssen"/>
                </div>
            </div>
        </div>

        <div className="voting-idea-wrapper">
            <div className="container">
                <div className="title-main">
                    <p className="h3 subtitle text-primary">From Prototype to Proof</p>
                    <h2 className="title display-3">Test Yor Idea With Confidence</h2>
                    <button type="button" className="btn btn-outline-white">Get Started</button>
                </div>
                <div className="idea-slider">
                    <Slider {...ideaSetting}>
                        <div className="idea-slide-main">
                            <span className="badge bg-light-grey">Transparent Voting</span>
                            <h2 className="display-3 title">Every vote is tracked for fairness.</h2>
                        </div>
                        <div className="idea-slide-main">
                            <span className="badge bg-light-grey">Every vote is tracked for fairness</span>
                            <h2 className="display-3 title">Transparent Voting <br/>fairness</h2>
                        </div>
                    </Slider>
                </div>
            </div>
        </div>

        <div className="awards-wrapper">
            <div className="container">
                <div className="title-main">
                    <p className="h3 subtitle text-primary">Recognition Meets Rewards</p>
                    <h2 className="title display-3">Inspire Votes, Win Awards</h2>
                    <button type="button" className="btn btn-primary">Get Started</button>
                </div>
                <div className="awards-slider">
                    <Slider {...awardSetting}>
                        <div className="award-slide-main">
                            <img src="https://img.freepik.com/free-vector/travel-blog-first-page-template-design-vector_53876-88253.jpg" alt="" />
                        </div>
                        <div className="award-slide-main">
                            <img src="https://img.freepik.com/free-vector/people-ordering-food-cafe-online-man-using-mobile-app-choosing-pizza-delivery-vector-illustration-application-restaurant-service-fast-food-concept_74855-8615.jpg" alt="" />
                        </div>
                        <div className="award-slide-main">
                            <img src="https://img.freepik.com/free-vector/travel-blog-first-page-template-design-vector_53876-88253.jpg" alt="" />
                        </div>
                        <div className="award-slide-main">
                            <img src="https://img.freepik.com/free-vector/people-ordering-food-cafe-online-man-using-mobile-app-choosing-pizza-delivery-vector-illustration-application-restaurant-service-fast-food-concept_74855-8615.jpg" alt="" />
                        </div>
                    </Slider>
                </div>
            </div>
        </div>

        <div className="health-wrapper">
            <div className="container">
                <div className="title-main">
                    <h2 className="title display-1">Launch in What Inspires You</h2>
                    <p className="h2 subtitle">From Wellness Tech To Research Tools, Find Your Perfect Match.</p>
                    <button type="button" className="btn btn-primary">Get Started</button>
                </div>
                <div className="health-img-main">
                    <img className="sideImg" src="https://img.freepik.com/free-photo/medical-banner-with-doctor-patient_23-2149611238.jpg" alt="" />
                    <img className="mainCenterImg" src="https://img.freepik.com/free-photo/medical-banner-with-doctor-patient_23-2149611238.jpg" alt="" />
                    <img className="sideImg" src="https://img.freepik.com/free-photo/medical-banner-with-doctor-patient_23-2149611238.jpg" alt="" />
                </div>
                <p className="h3 text-primary subtitleT">Health and Fitness</p>
            </div>
        </div>

        <div className="simple-txt-wrapper">
            <div className="container">
                <div className="row">
                    <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                        <div className="title-main">
                            <h2 className="title h4 fw-light">Build in Public, Grow in Value</h2>
                            <button type="button" className="btn-link primary">
                                Get Started
                                <span className="icon">
                                    <FontAwesomeIcon icon={faArrowRight} />
                                </span>
                            </button>
                        </div>
                    </div>
                    <div className="col-lg-5 col-md-6 col-sm-12 col-xs-12">
                        <div className="content-main">
                            <p className="h2">From Your First Prototype To Your First Sales, Keep The community In The Loop And Gain Trust.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="collaborators-wrapper">
            <div className="container">
                <div className="title-main">
                    <h2 className="display-3 title">Connect With Backers & Collaborators</h2>
                    <div className="sub-content-main">
                        <p className="h5 subtitle text-primary">Connect With Backers & Collaborators</p>
                        <p className="subtitle">Meet Innovators, Investors, And Industry Experts Ready To Help You Grow.</p>
                        <button type="button" className="btn btn-white">Get Started</button>
                    </div>
                </div>
            </div>
        </div>

        <div className="simple-txt-wrapper bg-dark">
            <div className="container">
                <div className="row">
                    <div className="col-lg-5 col-md-6 col-sm-12 col-xs-12">
                        <div className="content-main">
                            <p className="h2">Keep Building Excitement To Boost Votes, Attract Collaborators, And Secure Your Place At The Top.</p>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12">
                        <div className="title-main">
                            <h2 className="title h4 fw-light">Drive Momentum & Celebrate Success</h2>
                            <button type="button" className="btn-link primary">
                                Get Started
                                <span className="icon">
                                    <FontAwesomeIcon icon={faArrowRight} />
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="testimonial-wrapper">
            <div className="container">
                <div className="title-main">
                    <h2 className="display-3 title">What Others say</h2>
                </div>
                <div className="testimonial-slider">
                    <Slider {...testimonialSetting}>
                        <div className="testimonial-slide-box">
                            <div className="rating-stars">
                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                            </div>
                            <h2 className="title h4">Love the way they handle the they handle the order.</h2>
                            <p className="description-txt">Very professional and friendly at the same time. They packed the order on schedule and the detail of their wrapping is top notch. One of my best experience for buying online items. Surely will come back for another purchase.</p>
                            <div className="profile-box">
                                <img className="profile-img" src="https://cdn-icons-png.flaticon.com/512/1999/1999625.png" alt="" />
                                <div className="profile-txt">
                                    <h2 className="nm">Samantha William</h2>
                                    <p className="profession">Fashion Enthusiast</p>
                                </div>
                            </div>
                        </div>
                        <div className="testimonial-slide-box">
                            <div className="rating-stars">
                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                            </div>
                            <h2 className="title h4">Love the way they handle the they handle the order.</h2>
                            <p className="description-txt">Very professional and friendly at the same time. They packed the order on schedule and the detail of their wrapping is top notch. One of my best experience for buying online items. Surely will come back for another purchase.</p>
                            <div className="profile-box">
                                <img className="profile-img" src="https://cdn-icons-png.flaticon.com/512/2202/2202112.png" alt="" />
                                <div className="profile-txt">
                                    <h2 className="nm">Jack Wang</h2>
                                    <p className="profession">IP Attorney</p>
                                </div>
                            </div>
                        </div>
                        <div className="testimonial-slide-box">
                            <div className="rating-stars">
                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                            </div>
                            <h2 className="title h4">Love the way they handle the they handle the order.</h2>
                            <p className="description-txt">Very professional and friendly at the same time. They packed the order on schedule and the detail of their wrapping is top notch. One of my best experience for buying online items. Surely will come back for another purchase.</p>
                            <div className="profile-box">
                                <img className="profile-img" src="https://cdn-icons-png.flaticon.com/512/236/236831.png" alt="" />
                                <div className="profile-txt">
                                    <h2 className="nm">Ryan Haris</h2>
                                    <p className="profession">Senior Scientist</p>
                                </div>
                            </div>
                        </div>
                        <div className="testimonial-slide-box">
                            <div className="rating-stars">
                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                            </div>
                            <h2 className="title h4">Love the way they handle the they handle the order.</h2>
                            <p className="description-txt">Very professional and friendly at the same time. They packed the order on schedule and the detail of their wrapping is top notch. One of my best experience for buying online items. Surely will come back for another purchase.</p>
                            <div className="profile-box">
                                <img className="profile-img" src="https://cdn-icons-png.flaticon.com/512/1999/1999625.png" alt="" />
                                <div className="profile-txt">
                                    <h2 className="nm">Samantha William</h2>
                                    <p className="profession">Fashion Enthusiast</p>
                                </div>
                            </div>
                        </div>
                        <div className="testimonial-slide-box">
                            <div className="rating-stars">
                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                            </div>
                            <h2 className="title h4">Love the way they handle the they handle the order.</h2>
                            <p className="description-txt">Very professional and friendly at the same time. They packed the order on schedule and the detail of their wrapping is top notch. One of my best experience for buying online items. Surely will come back for another purchase.</p>
                            <div className="profile-box">
                                <img className="profile-img" src="https://cdn-icons-png.flaticon.com/512/2202/2202112.png" alt="" />
                                <div className="profile-txt">
                                    <h2 className="nm">Jack Wang</h2>
                                    <p className="profession">IP Attorney</p>
                                </div>
                            </div>
                        </div>
                        <div className="testimonial-slide-box">
                            <div className="rating-stars">
                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                                <FontAwesomeIcon icon={faStar} />
                            </div>
                            <h2 className="title h4">Love the way they handle the they handle the order.</h2>
                            <p className="description-txt">Very professional and friendly at the same time. They packed the order on schedule and the detail of their wrapping is top notch. One of my best experience for buying online items. Surely will come back for another purchase.</p>
                            <div className="profile-box">
                                <img className="profile-img" src="https://cdn-icons-png.flaticon.com/512/236/236831.png" alt="" />
                                <div className="profile-txt">
                                    <h2 className="nm">Ryan Haris</h2>
                                    <p className="profession">Senior Scientist</p>
                                </div>
                            </div>
                        </div>
                    </Slider>
                </div>
            </div>
        </div>

        <div className="guide-wrapper">
            <div className="container">
                <div className="title-main">
                    <h2 className="display-3 title">Get our Complete Guide</h2>
                </div>
                <form className="form-input">
                    <input type="text" name="" placeholder="Enter Mail" className="form-control" />
                    <button type="button" className="btn btn-primary">Get Guide</button>
                </form>
            </div>
        </div>

        <div className="connect-app-wrapper">
            <div className="container">
                <div className="title-main">
                    <h2 className="display-3 title">Go Mobile</h2>
                    <p className="subtitle text-primary">Stay connected on the move with our app.</p>
                    <div className="connect-img">
                        <Link to={"/"} className="store-img play-store">
                            <img src="https://cdn-icons-png.flaticon.com/512/2335/2335393.png " alt="" />
                        </Link>
                        <Link to={"/"} className="store-img app-store">
                            <img src="https://cdn-icons-png.flaticon.com/512/5977/5977575.png" alt="" />
                        </Link>
                    </div>
                </div>
            </div>
        </div>

    </main>

    <Footer />

    </>
  );
}
